import {
  CompanyHint,
  CreateCompanyHintRequest,
  UpdateCompanyHintRequest,
} from '@/models/hints'
import api from './api'

class HintsApiService {
  static getInstance(): HintsApiService {
    return this.instance || (this.instance = new this())
  }

  private static instance: HintsApiService

  private baseUrl = '/hints'

  private constructor() {
    // empty for linter
  }

  getHints(withContent?: boolean, scriptId?: string) {
    const params = new URLSearchParams({
      ...(scriptId ? { script: scriptId } : {}),
      ...(withContent ? { expand: 'content' } : {}),
    })
    const url = `${this.baseUrl}?${params.toString()}`
    return api.get<CompanyHint[]>(url)
  }

  create(data: CreateCompanyHintRequest) {
    return api.post<CompanyHint>(this.baseUrl, data)
  }

  update(id: string, data: UpdateCompanyHintRequest) {
    return api.post<boolean>(`${this.baseUrl}/${id}`, data)
  }

  delete(id: string) {
    return api.delete<boolean>(`${this.baseUrl}/${id}`)
  }

  viewHint(hint: CompanyHint) {
    const url = `${this.baseUrl}/${hint.id}?mode=view&expand=content`
    return api.get<CompanyHint>(url)
  }
}

export default HintsApiService.getInstance()
